// extracted by mini-css-extract-plugin
export var acitonButtons = "_ey-0";
export var additionalIcon = "_ey-f";
export var block = "_ey-1";
export var blockContent = "_ey-7";
export var blockDescription = "_ey-8";
export var blockIcon = "_ey-9";
export var blockTitle = "_ey-6";
export var border = "_ey-a";
export var center = "_ey-l";
export var edge = "_ey-b";
export var edgeLabel = "_ey-c";
export var edgePath = "_ey-d";
export var error = "_ey-e";
export var flowchart = "_ey-g";
export var flowchartContent = "_ey-h";
export var highlighted = "_ey-3";
export var hover = "_ey-4";
export var icon = "_ey-i";
export var left = "_ey-m";
export var navButton = "_ey-j";
export var navButtons = "_ey-k";
export var right = "_ey-n";
export var selected = "_ey-2";
export var small = "_ey-5";